<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="slide-x-transition"
        @click:outside="$emit('close')"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addkw-title"
        aria-describedby="addkw-desc">
        <v-card role="document" v-focus-trap="dialog">
            <div class="backsheet"></div>

            <!-- Close -->
            <v-btn class="close-btn" absolute top right icon color="primary" type="button" aria-label="Close dialog" @click="$emit('close')">
                <v-icon aria-hidden="true">mdi-close</v-icon>
            </v-btn>

            <v-card-text class="pt-5 pb-0">
                <div id="addkw-title" class="quarolbl pb-1">ADD KEYWORDS</div>
                <p id="addkw-desc" class="sr-only">Choose an assignment method, optionally select a topic, then paste or type keywords.</p>

                <v-row>
                    <v-col cols="12" sm="12" class="py-0">
                        <v-radio-group data-focus-first v-model="assignmentMethod" row aria-label="Keyword assignment method">
                            <!-- Automatic (disabled) -->
                            <v-radio value="auto" class="radio-option" disabled>
                                <template #label>
                                    <div class="option-content">
                                        <strong>Automatic Assignment <span style="color: green">(coming soon)</span></strong>
                                        <p class="mb-0" style="font-size: 14px">Keywords will automatically be assigned to the appropriate topics.</p>
                                    </div>
                                </template>
                            </v-radio>

                            <!-- Manual -->
                            <v-radio value="manual" class="radio-option">
                                <template #label>
                                    <div class="option-content">
                                        <strong>Manual Assignment</strong>
                                        <p class="mb-0" style="font-size: 14px">Decide yourself which topic the keywords should be assigned to.</p>
                                    </div>
                                </template>
                            </v-radio>

                            <!-- New topic -->
                            <v-radio value="new" class="radio-option">
                                <template #label>
                                    <div class="option-content">
                                        <strong>Create as new topic</strong>
                                        <p class="mb-0" style="font-size: 14px">A new topic with your keywords will be created. Make sure your keywords fit together!</p>
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <!-- Manual: select topic -->
                <div v-if="assignmentMethod === 'manual'">
                    <span class="quarolbl" id="lbl-topic">Select Topic</span>
                    <v-select rounded filled v-model="selectedTopic" :items="topicsFormatted" chips class="mt-3" label="Topic" :aria-labelledby="'lbl-topic'" />
                </div>

                <v-row no-gutters>
                    <span class="quarolbl" id="lbl-addkw">Add Keywords</span>
                    <v-btn @click="fromClipboard()" class="ml-auto" color="primary" small outlined rounded type="button" aria-label="Paste keywords from clipboard">
                        <v-icon size="16px" class="mr-1" aria-hidden="true">mdi-package-down</v-icon>
                        paste from clipboard
                    </v-btn>
                </v-row>

                <v-text-field
                    @keyup.enter="active.process == 'setup' ? fetchTopics() : addTermplacement()"
                    class="my-2"
                    rounded
                    filled
                    v-model="topics"
                    hint="Separate new keywords with commas"
                    persistent-hint
                    label="Keywords"
                    :aria-labelledby="'lbl-addkw'" />

                <v-select v-if="active.process == 'briefing' && active.area == 'term_placement'" v-model="tag" :items="tags_formatted" chips label="Term placement tag" />
            </v-card-text>

            <v-card-actions>
                <v-btn class="mx-auto" color="primary" rounded type="button" aria-label="Add keywords" @click="active.process == 'setup' ? fetchTopics() : addTermplacement()"> add </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Snackbar (bestehender Code, BITV live region) -->
        <v-snackbar v-if="notification" top v-model="notification.show" :color="notification.color" role="status" aria-live="polite" aria-atomic="true" :aria-describedby="'snackbar-text'">
            <v-icon aria-hidden="true">{{ notification.icon }}</v-icon>
            <span id="snackbar-text" class="font-weight-bold pl-2">
                {{ notification.message }}
            </span>
        </v-snackbar>
    </v-dialog>
</template>

<script>
    import datasources from "../helper/datasources.js"
    import locs from "../helper/locs"

    export default {
        props: {
            show: Boolean,
            active: Object,
            tags: undefined,
            project: Object
        },
        data() {
            return {
                tag: {},
                assignmentMethod: "manual",
                // selectedLocation: locs.stateItems[locs.stateItems.findIndex((x) => x.loc == "Germany")],
                // selectedLocation: localStorage.selectedLocation ? JSON.parse(localStorage.selectedLocation) : null,
                topics: "",
                selectedTopic: {},
                notification: null
            }
        },
        computed: {
            dialog() {
                return this.show
            },
            tags_formatted() {
                let keys = Object.keys(this.tags)
                return keys
            },
            topicsFormatted() {
                return this.project.topics.map((t) => t.keyword)
            }
        },
        methods: {
            fromClipboard() {
                console.log("add from clipboard")
                console.log(this.$store.state.clipboard_keywords.map((k) => k.keyword).join(", "))
                this.topics = this.$store.state.clipboard_keywords.map((k) => k.keyword).join(", ")
            },
            trackEvent(component, action, param1, param2) {
                try {
                    this.$matomo.trackEvent(component, action, param1, param2)
                } catch (error) {
                    console.log(error)
                    console.log("matomo blocked")
                }
            },
            async addTermplacement() {
                console.log("term added")

                try {
                    // const url = process.env.VUE_APP_APIURL + "/cs/briefing/term_placement/change"
                    // console.log(this.company_id)
                    // let post_data = {
                    //     company_id: this.company_id,
                    //     user_id: this.user_id,
                    //     project_id: this.project._id,
                    //     description: this.content
                    // }
                    // let response_data = await this.$helpers.axiosPost(url, post_data)
                    // this.notification = this.$helpers.createNotification("The description has been saved successfully!", "mdi-check-circle-outline", "primary")
                } catch (error) {
                    this.notification = this.$helpers.createNotification("Sorry, something went wrong! Please try again later!", "mdi-alert-circle-outline", "#fcba03")
                }
            },
            async fetchTopics() {
                try {
                    console.log("FETHCCHCHHCHC")
                    if (this.topics == "") return

                    let input = this.topics.split(",")
                    if (input.length > 20) {
                        this.btndisabled = false
                        this.loading = false
                        this.notification = this.$helpers.createNotification("Please do not enter more than 20 keywords!", "mdi-alert-circle-outline", "#FCBA03")
                        return
                    }
                    //check keywords for length < 81
                    let keywordsInvalid = this.$helpers.checkKeywordsLength(input)
                    if (keywordsInvalid) {
                        this.btndisabled = false
                        this.loading = false
                        this.notification = this.$helpers.createNotification("One keyword cannot be longer than 80 characters!", "mdi-alert-circle-outline", "#FCBA03")
                        return
                    }
                    let inputErrors = this.$helpers.validateUserInput(input)
                    if (inputErrors.length) {
                        let lines = inputErrors.reduce((lineString, entry) => lineString + (parseInt(entry.keyword) + 1) + ",", "")
                        this.notification = this.$helpers.createNotification("Please validate your input. Watch Keywords: " + lines, "mdi-alert-circle-outline", "#FCBA03")

                        this.loading = false
                        this.btndisabled = false
                        return
                    }
                    input = this.$helpers.replaceSpecialCharacters(input)
                    input = input.filter((x) => x !== " " && x !== "")
                    this.$emit("started")

                    // let date = new Date()
                    // let year = date.getFullYear()
                    // year -= 1
                    // date.setFullYear(year)
                    // date = date.toISOString().split("T")[0]
                    let options = {
                        keywords: input,
                        location_code: this.project.langloc.location_code,
                        language_code: this.project.langloc.language_code
                        // date_from: date
                    }
                    console.log("FETCH")
                    let kw_response = await datasources.fetchDFS(options, localStorage.company_id, localStorage.id, "historic_searchvolume")
                    console.log(kw_response.result.items)

                    console.log("EMIT")
                    if (!kw_response.result) kw_response.result = {}
                    if (!kw_response.result.items) kw_response.result.items = []

                    input.map((x) => {
                        if (kw_response.result.items.findIndex((item) => item.keyword == x) == -1) {
                            let keyword_object = {
                                keyword_info: {
                                    monthly_searches: [],
                                    avgsv: 0
                                },
                                keyword: x,
                                selected: true
                            }
                            kw_response.result.items.push(keyword_object)
                        }
                    })
                    if (kw_response.result.items !== null && kw_response.result.items.length) {
                        this.$emit("added", kw_response.result.items, this.assignmentMethod, this.selectedTopic)
                        this.trackEvent("CS - Add Topics Manually - success", this.topics, "", "")
                    } else {
                        this.$emit("added", [])
                        this.trackEvent("CS - Add Topics Manually - empty", this.topics, "", "")
                    }

                    this.topics = ""
                } catch (error) {
                    console.log(error)
                    this.$emit("failed")
                    this.topics = ""
                }
            }
        }
    }
</script>

<style scoped>
    .close-btn {
        top: 5px;
        right: 5px;
    }
    /* Hover-Effekt für die Radio-Optionen */
    .radio-option:hover {
        background-color: #f0f0f0;
        border-radius: 8px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    /* Hover-Effekt für die Option-Text */
    .radio-option .option-content:hover strong {
        color: #000000; /* Ändert die Textfarbe beim Hover */
        transition: color 0.3s ease;
    }
    .radio-option {
        padding: 15px;
    }
    /* Abstände zwischen den Radio-Optionen und den Labels */
    .option-content {
        margin-left: 10px;
    }
</style>
